export default __webpack_public_path__ + "static/sames-d440c53813b07de5a258848543d9f169.png";